var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input_light",attrs:{"placeholder":_vm.placeholder,"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }